import React from 'react'
import Resgister from '../components/Resgister'



export default function Home() {

  return (
    <div>
      <Resgister />
    </div>
  )
}